import type { CityConfig } from "../city-template/types";

export const shawneeConfig: CityConfig = {
  city: "Shawnee",
  state: "Oklahoma",
  stateAbbr: "OK",
  slug: "shawnee",
  route: "/shawnee",
  title: "Emergency Passport Shawnee, OK | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Shawnee, OK — as fast as 24 hours. Serving OBU students and Central Oklahoma Frontier Country. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Shawnee, OK",
  heroSubtitle: "OBU study abroad to London with 10 days notice and no passport? Citizen Potawatomi Nation cultural exchange trip to Canada need fast documents? Business trip to Asia from Frontier Country with expired documents? We help Shawnee and Central Oklahoma residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Shawnee%20Oklahoma%20historic%20downtown%20brick%20streets%20Mabee-Gerrer%20Museum%20of%20Art%20Oklahoma%20Baptist%20University%20campus%20with%20iconic%20Raley%20Chapel%20golden%20dome%20North%20Canadian%20River%20winding%20through%20town%20Central%20Oklahoma%20prairie%20landscape%20golden%20sunset%20warm%20light%20Frontier%20Country%20professional%20drone%20photography&width=1800&height=700&seq=shawnee-ok-hero-2026&orientation=landscape",
  heroImageAlt: "Shawnee Oklahoma OBU campus and historic downtown with golden prairie sunset",
  geoPosition: "35.3273;-96.9253",
  geoPlacename: "Shawnee, Oklahoma",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "1100 Commerce Street, Suite 900, Dallas, TX 75242",
    distance: "Located in downtown Dallas — approximately 240 miles south of Shawnee via I-35",
  },
  nearbyCitiesZips: [
    { name: "Shawnee", zips: "74801, 74802, 74804" },
    { name: "Tecumseh", zips: "74873" },
    { name: "Seminole", zips: "74818, 74868" },
    { name: "Prague", zips: "74864" },
    { name: "Chandler", zips: "74834" },
    { name: "Meeker", zips: "74855" },
    { name: "Harrah", zips: "73045" },
    { name: "McLoud", zips: "74851" },
    { name: "Ada", zips: "74820, 74821" },
    { name: "Pauls Valley", zips: "73075" },
    { name: "Purcell", zips: "73080" },
    { name: "Norman", zips: "73019, 73069" },
    { name: "Oklahoma City", zips: "73102, 73103" },
    { name: "Maud", zips: "74854" },
    { name: "Earlsboro", zips: "74840" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent OBU and Central Oklahoma departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Frontier Country Region", desc: "Serving Shawnee, Tecumseh, Seminole, Prague, and Central Oklahoma" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Oklahoma City, OK", route: "/oklahoma-city" },
    { name: "Fast passport renewal in Norman, OK", route: "/norman" },
    { name: "Emergency passport help in Edmond, OK", route: "/edmond" },
    { name: "Urgent passport services in Tulsa, OK", route: "/tulsa" },
    { name: "Same-day passport help in Dallas, TX", route: "/dallas" },
    { name: "Passport courier services in Moore, OK", route: "/moore" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Shawnee remotely via secure courier. We do not have a walk-in office in Shawnee — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Pottawatomie County and Central Oklahoma.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Pottawatomie County and the Central Oklahoma Frontier Country region including Seminole, Lincoln, and Pontotoc counties",
  serviceAreaIntro: "From the iconic golden dome of Raley Chapel at Oklahoma Baptist University to the historic brick streets and railroad heritage of downtown Shawnee, from the Citizen Potawatomi Nation Cultural Heritage Center to the oil-rich communities of Seminole and Prague, from the Route 66 charm of Chandler to the agricultural towns of Meeker and McLoud — Fast Passport Center serves the entire Central Oklahoma Frontier Country region. We regularly help OBU students, tribal members, and local travelers get their passports fast without the 240-mile drive to Dallas.",
  nearbyCitiesIntro: "We serve all Shawnee neighborhoods and the surrounding Central Oklahoma area including Tecumseh, Seminole, Prague, Chandler, Meeker, Harrah, and McLoud. If you are anywhere in Pottawatomie County, Seminole County, or Lincoln County, we have you covered.",
  howItWorksIntro: "Most Shawnee travelers complete everything online and ship documents overnight. No need to drive to Dallas or wait in line at the regional agency.",
  mistakesIntro: "Shawnee travelers often face a 4-hour drive to the nearest regional passport agency in Dallas. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Shawnee students and Central Oklahoma travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Shawnee? Here are the most common ones we hear from OBU and Pottawatomie County travelers.",
  statePageRoute: "/states/oklahoma",
  statePageName: "Oklahoma",
  dmvWebsite: "https://oklahoma.gov/dps.html",
  dmvLabel: "Oklahoma DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Shawnee travelers with immediate departure needs — as fast as 24 hours for study abroad or urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Shawnee travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Shawnee with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance for Shawnee and OBU students with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Rachel M.",
      location: "Shawnee, OK",
      rating: 5,
      text: "OBU mission trip to Guatemala was in 6 days when I realized my passport expired. Fast Passport Center got it renewed in 30 hours. Made my flight with hours to spare!",
      service: "Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Shawnee, OK",
      rating: 5,
      text: "Business trip to Tokyo booked last minute. Fast Passport Center had my passport in 2 days. The dedicated agent was incredible. Saved my deal.",
      service: "Emergency Passport",
    },
    {
      name: "Angela P.",
      location: "Seminole, OK",
      rating: 5,
      text: "Family reunion in Ireland. Fast Passport Center handled all 3 passports in 3 days. Amazing for Central Oklahoma. From Seminole to Shannon — thank you!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "shawnee-ok-1",
      name: "Shawnee Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "116 E 9th St",
      city: "Shawnee",
      state: "OK",
      zip: "74801",
      phone: "(405) 273-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Shawnee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Shawnee facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "shawnee-ok-2",
      name: "Pottawatomie County Court Clerk",
      type: "County Court Clerk Passport Acceptance",
      address: "325 N Broadway Ave, Suite 204",
      city: "Shawnee",
      state: "OK",
      zip: "74801",
      phone: "(405) 273-3624",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Shawnee Courthouse",
      website: "https://www.pottawatomiecountyok.com",
      websiteLabel: "Pottawatomie County Court Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "shawnee-ok-3",
      name: "Seminole Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "110 N 4th St",
      city: "Seminole",
      state: "OK",
      zip: "74868",
      phone: "(405) 382-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles east of Shawnee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Seminole County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "shawnee-ok-4",
      name: "Ada Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 S Townsend Ave",
      city: "Ada",
      state: "OK",
      zip: "74820",
      phone: "(580) 332-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "45 miles south of Shawnee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Pontotoc County and ECU area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "shawnee-ok-5",
      name: "Chandler Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "700 Manvel Ave",
      city: "Chandler",
      state: "OK",
      zip: "74834",
      phone: "(405) 258-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles north of Shawnee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lincoln County and Route 66 corridor. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Dallas", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Shawnee photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Pottawatomie County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Shawnee applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Dallas regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many OBU student families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Shawnee travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Shawnee." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Shawnee address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Shawnee before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Shawnee for travelers with urgent international flights or study abroad deadlines. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4-hour drive to Dallas." },
    { q: "How fast can I renew my passport in Shawnee?", a: "Fast Passport Center offers fast passport renewal in Shawnee in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Shawnee?", a: "The nearest regional passport agency to Shawnee is the Dallas Passport Agency, approximately 240 miles south via I-35. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Shawnee without any in-person agency visit required." },
    { q: "Can OBU students get expedited passports for mission trips?", a: "Absolutely. Fast Passport Center helps OBU students get expedited passports for mission trips and study abroad programs. We understand tight academic timelines and can process passports in 24–48 hours for last-minute departures to Guatemala, Kenya, China, and other destinations." },
    { q: "Do you serve the entire Central Oklahoma Frontier Country?", a: "Absolutely. Fast Passport Center serves the entire Central Oklahoma Frontier Country region including Shawnee, Tecumseh, Seminole, Prague, Chandler, Ada, and surrounding areas. Our courier service works seamlessly from any address in Pottawatomie County, Seminole County, or Lincoln County." },
    { q: "Can I expedite a child passport in Shawnee?", a: "Yes. Fast Passport Center expedites child passports in Shawnee for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Frontier Country families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Shawnee with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Dallas Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Shawnee", address: "2001 N Harrison Ave, Shawnee, OK 74804", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Shawnee", address: "1900 N Kickapoo Ave, Shawnee, OK 74804", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Ada", address: "1419 N Country Club Rd, Ada, OK 74820", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walmart Supercenter — Seminole", address: "2200 Boren Blvd, Seminole, OK 74868", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Oklahoma DPS — Shawnee",
      address: "400 N Bell Ave, Shawnee, OK 74801",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Oklahoma DPS — Ada",
      address: "1300 Cradduck Rd, Ada, OK 74820",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Pontotoc County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Oklahoma DPS — Seminole",
      address: "201 N 2nd St, Seminole, OK 74868",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Seminole County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SNL",
      name: "Shawnee Regional Airport",
      distance: "3 miles northwest of downtown Shawnee",
      address: "2202 Airport Dr, Shawnee, OK 74804",
      note: "Regional airport serving Shawnee. About 8 minutes from downtown. General aviation and charter services.",
      flightUrl: "https://www.shawneeok.org/airport",
      flightLabel: "SNL Airport",
      featured: true,
    },
    {
      code: "OKC",
      name: "Will Rogers World Airport",
      distance: "40 miles west of Shawnee",
      address: "7100 Terminal Dr, Oklahoma City, OK 73159",
      note: "Major Oklahoma airport with direct flights nationwide. About 40 minutes from Shawnee via I-40.",
      flightUrl: "https://flyokc.com/",
      flightLabel: "OKC Airport",
      featured: false,
    },
    {
      code: "TUL",
      name: "Tulsa International Airport",
      distance: "90 miles northeast of Shawnee",
      address: "7777 E Apache St, Tulsa, OK 74115",
      note: "Regional hub with direct flights to major cities. About 1 hour 20 minutes from Shawnee.",
      flightUrl: "https://www.tulsaairports.com/",
      flightLabel: "TUL Airport",
      featured: false,
    },
  ],
};